define('modules/modal/modal',[
	'app',
	'jquery',
	'backbone'
],
function(app, $, Backbone) {

	return Backbone.View.extend({
		el: '.js-modal-open',
		isActive: false,
		modalOverlay: '',
		modalContainer: '',

		initialize: function(){
			_.bindAll(this, 'createModal', 'showModal', 'hideModal', 'createEvents');
			this.createModal()
			this.createEvents()
		},
        
        createModal: function() {
			$('<div data-modal="overlay" class="modal-overlay js-modal-close"></div>').appendTo('body')
			var closeBtn = '<div class="js-modal-close text-right cursor-pointer"><img src="/sites/eresources/themes/ecatalogue/img/icon/modal-close.png" alt="modal close" /></div>'
			var html = '<div data-modal="container" class="modal">' + closeBtn + '<div data-modal="content" class="modal-content"></div></div>'
			$(html).appendTo('body')
			this.modalOverlay = $('[data-modal="overlay"]')
			this.modalContainer = $('[data-modal="container"]')
		},
		
        showModal: function() {
			$(this.modalOverlay).addClass('modal-overlay--show')
			$(this.modalContainer).addClass('modal--show')
		},
		
		hideModal: function() {
			$(this.modalOverlay).removeClass('modal-overlay--show')
			$(this.modalContainer).removeClass('modal--show')
		},

		createEvents: function() {
			$('.js-modal-open').on('click', this.showModal)
			$('.js-modal-close').on('click', this.hideModal)
		}

	});

});

